import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from "@angular/platform-browser";
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { SideBarComponent } from './layout/side-bar/side-bar.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthGuardService } from './common/services/authguard.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../core/common/interceptor/token.interceptor';
import { ErrorInterceptor } from '../core/common/interceptor/error.interceptor';
import { MasterDataRepository } from './data/repositories/masterdata.repository';
import { SharedDataRepository } from './data/repositories/shared.repository';
import { TestDataRepository } from './data/repositories/testdata.repository';
import { CertificateDataRepository } from './data/repositories/certificatedata.repository';
import { TestService } from '../features/test/services/test.service';
import { CertificateService } from '../features/certificate/services/certificate.service';
import { ProjectService } from '../features/project/services/project.service';
import { ProjectDataRepository } from './data/repositories/projectdata.repository';
import { MasterSideBarComponent } from './layout/master-side-bar/master-side-bar.component';
import { AdminDataRepository } from './data/repositories/admindata.repository';
import { DashboardRepository } from './data/repositories/dashboard.repositort';
import { DashboardService } from '../features/home/service/dashboard.service';
import { PrimeNgModules } from '../primeng.module';
import { ConstructionElementDataRepository } from './data/repositories/constructionelementdata.repository';
import { ConstructionElementService } from '../features/construction-element/services/constructionelement.service';
 
@NgModule({
  declarations: [
    MainLayoutComponent,
    SideBarComponent,
    MasterSideBarComponent,
  ],
  imports: [
    RouterModule,
    BrowserModule,
    PrimeNgModules],
  providers: [ 
    TestService,
    ProjectService,
    CertificateService,
    DashboardService,
    MasterDataRepository,
    SharedDataRepository,
    TestDataRepository,
    CertificateDataRepository,
    ProjectDataRepository,
    AdminDataRepository,
    DashboardRepository,
    ConstructionElementService,
    ConstructionElementDataRepository
],
  exports: [MainLayoutComponent]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [AuthGuardService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true,
        },
        MessageService,
        TranslateService,
        ConfirmationService
      ]
    }
  }
}